module.exports = __webpack_public_path__ + "branding-cover.b079594237d58f3525446dcd0db209cc.png";